// extracted by mini-css-extract-plugin
export default {"container":"QjuFd","title":"mXD1P"};